import { ActionType } from '../constants/ActionTypes';
import { Constants } from '../constants/Constants';
import { RestPath } from '../constants/SitePaths'
import config from '../constants/Configs';
import { message } from 'antd';
import axios from 'axios';

// Create Domain
export const createDomainBegin = () => ({
    type: ActionType.CREATE_DOMAIN_BEGIN
});

export const createDomainSuccess = user => ({
    type: ActionType.CREATE_DOMAIN_SUCCESS,
    payload: { user }
});

export const createDomainError = (user, error) => ({
    type: ActionType.CREATE_DOMAIN_FAILURE,
    payload: { error, user }
});

// Set Domain Status
export const setDomainStatusBegin = () => ({
    type: ActionType.SET_DOMAIN_STATUS_BEGIN
});

export const setDomainStatusSuccess = user => ({
    type: ActionType.SET_DOMAIN_STATUS_SUCCESS,
    payload: { user }
});

export const setDomainStatusError = (user, error) => ({
    type: ActionType.SET_DOMAIN_STATUS_FAILURE,
    payload: { error, user }
});

// Get Domains for Affiliate
export const getDomainsForAffiliateBegin = () => ({
    type: ActionType.GET_DOMAIN_AFFILIATE_BEGIN
});

export const getDomainsForAffiliateSuccess = (data) => ({
    type: ActionType.GET_DOMAIN_AFFILIATE_SUCCESS,
    payload: data
});

export const getDomainsForAffiliateError = (data) => ({
    type: ActionType.GET_DOMAIN_AFFILIATE_FAILURE,
    payload: data
});

// Get Domains for SubAffiliate
export const getDomainsForSubAffiliateBegin = () => ({
    type: ActionType.GET_DOMAIN_SUBAFFILIATE_BEGIN
});

export const getDomainsForSubAffiliateSuccess = (data) => ({
    type: ActionType.GET_DOMAIN_SUBAFFILIATE_SUCCESS,
    payload: data
});

export const getDomainsForSubAffiliateError = (data) => ({
    type: ActionType.GET_DOMAIN_SUBAFFILIATE_FAILURE,
    payload: data
});

// Delete Domain
export const deleteDomainBegin = () => ({
    type: ActionType.DELETE_DOMAIN_BEGIN
});

export const deleteDomainSuccess = (data) => ({
    type: ActionType.DELETE_DOMAIN_SUCCESS,
    payload: data
});

export const deleteDomainError = (data) => ({
    type: ActionType.DELETE_DOMAIN_ERROR,
    payload: data
});

export function createNewDomain(data, intl, affiliateId) {
    return dispatch => {
        dispatch(createDomainBegin());
        const params = {
            AffiliateId: data.affiliateId,
            Domain: data.domain,
            Status: data.status,
        };

        //Encode the data
        return axios({
            method: Constants.POST,
            url: config.BASE_URL + RestPath.DOMAIN_CREATE,
            data: JSON.stringify(params),

        }).then((response) => {
            dispatch(createDomainSuccess(response.data));
            message.success(intl.messages.success_domain);

            return response.data;
        })
            .catch((error) => {
                dispatch(createDomainError(params, error));
            });
    };
}

export function setDomainStatus(data, intl) {
    return dispatch => {
        dispatch(setDomainStatusBegin());
        const params = {
            id: data.id,
            status: data.status,
        };

        //Encode the data
        return axios({
            method: Constants.PUT,
            url: config.BASE_URL + RestPath.DOMAIN_SET_STATUS,
            data: JSON.stringify(params),

        }).then((response) => {
            dispatch(setDomainStatusSuccess(response.data));
            message.success(intl.messages.status_changed);

            return response.data;
        })
            .catch((error) => {
                dispatch(setDomainStatusError(params, error));
            });
    };
}

export function getDomainsForAffiliate(mainPartnerId, pageNumber, formData) {
    return dispatch => {
        dispatch(getDomainsForAffiliateBegin());

        let params = formData ? {
            mainPartnerId,
            pageNumber,
            affiliateId: formData.filterAffId,
            date: formData.filterDate,
            status: formData.filterStatus
        } : { mainPartnerId, pageNumber }

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.DOMAIN_GET_FOR_AFFILIATE,
            params: params

        }).then((response) => {
            dispatch(getDomainsForAffiliateSuccess(response.data));

            return response.data;
        })
            .catch((error) => {
                dispatch(getDomainsForAffiliateError(error));
            });
    }
}

export function getDomainsForSubAffiliate(affiliateId, pageNumber) {
    return dispatch => {
        dispatch(getDomainsForSubAffiliateBegin());

        const params = {
            affiliateId,
            pageNumber
        };

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.DOMAIN_GET_FOR_SUBAFFILIATE,
            params: params

        }).then((response) => {
            dispatch(getDomainsForSubAffiliateSuccess(response.data));

            return response.data;
        })
            .catch((error) => {
                dispatch(getDomainsForSubAffiliateError(error));
            });
    }
}

export function deleteDomain(mainPartnerId, id, intl) {
    return dispatch => {
        dispatch(deleteDomainBegin());

        const params = {
            id,
            mainPartnerId,
        };

        return axios({
            method: Constants.DELETE,
            url: config.BASE_URL + RestPath.DELETE_DOMAIN,
            params: params
        }).then((response) => {
            dispatch(deleteDomainSuccess(response.data));
            message.success(intl.messages.delete_domain);
            return response.data;
        })
            .catch((error) => {
                dispatch(deleteDomainError(error));
            });
    }
}

export function checkActivityForAffiliate(id) {
    return dispatch => {
        dispatch(getDomainsForAffiliateBegin());

        let params = {
            id
        };

        return axios({
            method: Constants.PUT,
            url: config.BASE_URL + RestPath.ACTIVATION_CHECK,
            params: params

        }).then((response) => {
            dispatch(getDomainsForAffiliateSuccess(response.data));

            return response.data;
        })
        .catch((error) => {
            dispatch(getDomainsForAffiliateError(error));
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/DomainsActions.js